<header class="header-style1" id="header-section1">
    <!-- nav -->
    <nav
        class="navbar navbar-expand-lg  black-header no-margin alt-font shrink-transparent-header-dark header-border-light dark-header sm-padding-shring-22px">
        <div class="container ">
            <div class="row display-block w-100">
                <div class="col-md-2 col-sm-4 col-6">
                    <div class="logo xs-padding-nineteen-left">
                        <a href="#home" class="inner-link"><img alt=""
                                src="assets/image/Logo-Servios_vertical_blanco.png"></a>
                    </div>
                </div>
                <div class="col-md-10 col-sm-8 col-6 position-inherit xs-no-padding-left">
                    <a href="#" data-target="#bs-example-navbar-collapse-1" data-toggle="collapse"
                        class="navbar-toggle collapsed d-none sm-display-block sm-display-flex justify-content-end">
                        <h3 class="p-1 text-white"><i class="fas fa-bars"></i></h3>
                    </a>
                    <div id="bs-example-navbar-collapse-1"
                        class="collapse navbar-collapse clear-both sm-position-fixed">
                        <ul class="nav navbar-nav navigation-menu justify-content-end">
                            <li><a class="inner-link" href="#home1">INICIO</a></li>
                            <li><a class="inner-link" href="#about-company">QUIENES SOMOS</a></li>
                            <li><a class="inner-link" href="#services">SERVICIOS</a></li>
                            <li><a class="inner-link" href="#portfolio">TRABAJOS REALIZADOS</a></li>
                            <li><a class="inner-link" href="#reviews">TESTIMONIOS</a></li>
                            <li><a class="inner-link" href="#contact">CONTACTO</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <!-- end nav -->
</header>